import { Link } from "react-router-dom";
import { ShieldCheck, Instagram, ExternalLink, ShoppingBag } from "lucide-react";
import { NAV, SITE } from "../site";
import GummyBurger from "./GummyBurger";

export default function Footer() {
  return (
    <footer className="bg-plum text-white">
      <div className="container-site grid grid-cols-1 gap-10 py-14 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2.5">
            <GummyBurger className="h-10 w-11" title="Logo Yupi Burger" />
            <span className="font-display text-xl font-bold">
              Yupi<span className="text-bun">Burger</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-white/70">
            {SITE.tagline} Permen gummy berbentuk burger yang diproduksi oleh {SITE.company}.
          </p>
          <div
            data-testid="footer-halal-badge"
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-lettuce/40 bg-lettuce/15 px-4 py-2 text-xs font-bold uppercase tracking-wider text-lettuce-light"
          >
            <ShieldCheck className="h-4 w-4" aria-hidden="true" />
            Tersertifikasi Halal MUI &amp; BPJPH
          </div>
        </div>

        <nav aria-label="Navigasi footer">
          <h2 className="font-display text-sm font-bold uppercase tracking-widest text-bun">Jelajahi</h2>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  data-testid={`footer-${item.testid}`}
                  className="text-sm text-white/75 transition-colors hover:text-bun"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <h2 className="font-display text-sm font-bold uppercase tracking-widest text-bun">Channel Resmi Yupi</h2>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li>
              <a
                href={SITE.official.store}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-yupiland-store"
                className="inline-flex items-center gap-2 text-white/75 transition-colors hover:text-bun"
              >
                <ShoppingBag className="h-4 w-4" aria-hidden="true" />
                Yupiland Official Store
                <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href={SITE.official.corporate}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-yupi-corporate"
                className="inline-flex items-center gap-2 text-white/75 transition-colors hover:text-bun"
              >
                Situs Resmi Yupi (yupi.co.id)
                <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
              </a>
            </li>
            <li>
              <a
                href={SITE.official.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-official-instagram-link"
                className="inline-flex items-center gap-2 text-white/75 transition-colors hover:text-bun"
              >
                <Instagram className="h-4 w-4" aria-hidden="true" />
                @yupi.gummy
                <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-site flex flex-col gap-2 py-6 text-xs text-white/55 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Yupi Burger — {SITE.company}.</p>
          <p>
            Yupi dan Yupi Burger adalah merek milik {SITE.company}. Informasi resmi perusahaan:
            yupi.co.id.
          </p>
        </div>
      </div>
    </footer>
  );
}
